import { minutesInHour } from 'helpers/timeConsts';

const displayWorkTime = (minuteTime: number): string => {
  const hours = Math.floor(minuteTime / minutesInHour);
  const minutes = minuteTime % minutesInHour;
  return `${hours}h ${minutes}min`;
};

export default displayWorkTime;
